let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kd6Lw")).then(() => parcelRequire('1y6fn'));